/**
 * Vendor Import — Review step locked row.
 *
 * Renders a single core-property mapping the engine applied automatically.
 * Unlike ReviewRow, this is non-editable — no Select, no override. Extracted
 * as its own component so it's memoized independently, mirroring ReviewRow.
 */

import React from 'react';

import { Table } from '@/lib/base/table/table';

import type { CoreMapping } from './types';

interface LockedReviewRowProps {
  rowKey: string;
  mapping: CoreMapping;
}

function LockedReviewRowComponent({ rowKey, mapping }: LockedReviewRowProps) {
  return (
    <Table.Row id={rowKey}>
      <Table.Cell>
        <span className='text-sm font-medium text-primary'>
          {mapping.label}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className='text-sm text-tertiary'>
          Mapped to your "{mapping.target_property_name}" property
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className='text-sm text-tertiary'>Locked</span>
      </Table.Cell>
    </Table.Row>
  );
}

export const LockedReviewRow = React.memo(LockedReviewRowComponent);
